// /index.js
import { initSpBase } from "./common/spBase.js";
// import { initCareerAccordion } from "./common/accordion.js";
import { initModal } from "./common/modal.js";
import { revealSection, revealOnLoad, revealSequence } from "./effects/fadeObserver.js";

document.addEventListener("DOMContentLoaded", () => {
  // ---- SPベース共通初期化（ヘッダー・ドロワー・一次スクロールフラグ） ----
  initSpBase();

  // ---- アコーディオン ----
  // initCareerAccordion();

  // ---- フェード系 ----
  // FV：.js-fv 内の .reveal を読み込み時に段階表示
  revealOnLoad(".js-fv .reveal", { base: 0.2, step: 0.06 });
  // ふつうのセクション：スクロールインで表示
  revealSection(".reveal");
  // 連続表示：コンテナ単位で内側の .reveal を順番に
  revealSequence(".js-stagger", ".reveal", { rootMargin: "0% 0% -12% 0", threshold: 0 }, { base: 0, step: 0.08 });

  const els = document.querySelectorAll(".js-reveal");
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
        }
      });
    },
    { threshold: 0.3 },
  );
  els.forEach((el) => io.observe(el));

  // ---- Splide ----
  const aboutEls = document.querySelectorAll(".l-about__slider");

  if (aboutEls.length && window.Splide) {
    const baseOptions = {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "20px",
      arrows: false,
      pagination: false,
      drag: false, // 手動ドラッグしたければ true
    };

    const hasAutoScroll = window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll;

    aboutEls.forEach((el) => {
      const isReverse = el.dataset.reverse === "1"; // タイプB判定
      const baseSpeed = el.dataset.speed ? parseFloat(el.dataset.speed) : 0.5; // 任意で data-speed も使える
      if (hasAutoScroll) {
        const splide = new Splide(el, {
          ...baseOptions,
          autoScroll: {
            speed: isReverse ? -Math.abs(baseSpeed) : Math.abs(baseSpeed),
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDrag: false,
          },
        });
        splide.mount(window.splide.Extensions);
      } else {
        // 拡張が読み込めなかった時のフォールバック（1枚ずつの自動送り）
        const splide = new Splide(el, {
          ...baseOptions,
          autoplay: true,
          interval: 2500,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          // 方向を逆に見せたい場合、RTLで見た目だけ逆転（完全な逆送りではない）
          direction: isReverse ? "rtl" : "ltr",
        });
        splide.mount();
      }
    });
  }

  // ====== モーダル起動（.Contents 内に開く場合） ======

  initModal({
    // root: document.querySelector(".frame"),
  });

  // ---- PCで tel: 無効化 ----
  const mql = matchMedia("(hover: hover) and (pointer: fine)");
  const prevent = (e) => e.preventDefault();
  const toggleTelLinks = () => {
    document.querySelectorAll('a[href^="tel:"]').forEach((a) => {
      if (mql.matches) {
        if (a.dataset.pcDisabled) return;
        a.addEventListener("click", prevent, { passive: false });
        a.setAttribute("aria-disabled", "true");
        a.tabIndex = -1;
        a.dataset.pcDisabled = "1";
      } else if (a.dataset.pcDisabled) {
        a.removeEventListener("click", prevent);
        a.removeAttribute("aria-disabled");
        a.removeAttribute("tabindex");
        delete a.dataset.pcDisabled;
      }
    });
  };
  toggleTelLinks();
  mql.addEventListener("change", toggleTelLinks);
});

// CF7 送信成功 → サンクスへ
if (location.pathname === "/entry/" || location.pathname === "/entry") {
  document.addEventListener("wpcf7mailsent", () => {
    location.href = "/entry/thanks/";
  });
}
